import PropTypes from 'prop-types';
import React from 'react';

import { formatDate, formatNumber } from '../utils';
import NameCell from './NameCell';
import StatusPill from './StatusPill';

// Renders one table cell for a given column key.
const Cell = ({ colKey, row }) => {
  switch (colKey) {
    case 'artist':
      return <NameCell row={row} />;
    case 'status':
      return <StatusPill onTour={row.on_tour} />;
    case 'last_show': {
      const label = formatDate(row.last_show_date);
      return label ? <span>{label}</span> : null;
    }
    case 'avg_cap':
      return <span className="ab-num">{formatNumber(row.avg_cap)}</span>;
    case 'facebook':
      return <span className="ab-num">{formatNumber(row.facebook)}</span>;
    case 'spotify':
      return <span className="ab-num">{formatNumber(row.spotify)}</span>;
    case 'genre':
      return <span>{row.genre || '—'}</span>;
    case 'agency':
      return <span>{row.agency || '—'}</span>;
    default:
      return null;
  }
};
Cell.propTypes = { colKey: PropTypes.string.isRequired, row: PropTypes.object.isRequired };

export default Cell;
